import { motion } from "framer-motion";
import { Layout } from "@/components/Layout";

export default function PrivacyPolicy() {
  return (
    <Layout>
      <div className="prose prose-invert max-w-4xl mx-auto">
        <h1 className="text-2xl font-pixel mb-8 text-[#9333EA]">Privacy Policy</h1>
        <div className="space-y-8 text-xs leading-relaxed text-gray-400">
          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Information We Collect</h2>
            <p className="mb-4">We collect minimal information necessary to provide our NFT minting service. This includes:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Wallet addresses</li>
              <li>Transaction data</li>
              <li>Website usage information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">How We Use Your Information</h2>
            <p className="mb-4">Your information is used to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Process NFT minting transactions</li>
              <li>Verify ownership of NFTs</li>
              <li>Improve our website and services</li>
              <li>Communicate important updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Data Security</h2>
            <p className="mb-4">We implement appropriate security measures to protect your information. However, please note that no method of transmission over the internet is 100% secure.</p>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Blockchain Data</h2>
            <p className="mb-4">Please be aware that blockchain transactions are public by nature. Your wallet address and transaction history will be visible on the blockchain.</p>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal information</li>
              <li>Request correction of your data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Updates to This Policy</h2>
            <p className="mb-4">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </section>
        </div>
      </div>
    </Layout>
  );
} 